/**
 * Legacy channel host — iframe strangler until a native module exists.
 */
export function createLegacyIframeChannel(project) {
  let iframe = null;
  let onMessage = null;

  return {
    meta: project,

    async mount(el, { onChannelGo, onMenuOpen } = {}) {
      el.innerHTML = '';
      iframe = document.createElement('iframe');
      iframe.id = 'nt-channel';
      iframe.title = project.vcrLabel || project.name;
      iframe.allow = 'autoplay; microphone';
      iframe.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;border:0;display:block;background:#000';
      iframe.src = `/_channels/${encodeURIComponent(project.id)}/index.html?embed=1`;
      el.appendChild(iframe);

      onMessage = (e) => {
        if (!e.data || typeof e.data !== 'object') return;
        if (e.data.type === 'nt-menu-open' && onMenuOpen) onMenuOpen();
        if (e.data.type === 'nt-channel-go' && onChannelGo) {
          onChannelGo(parseInt(e.data.idx, 10));
        }
      };
      window.addEventListener('message', onMessage);
    },

    async unmount() {
      if (onMessage) window.removeEventListener('message', onMessage);
      onMessage = null;
      if (iframe) {
        iframe.src = 'about:blank';
        iframe.remove();
        iframe = null;
      }
    },
  };
}
